module.exports = __webpack_public_path__ + "static/media/affordable-catering-1.fbb8e7a0.jpg";